import { Text } from '../../../CommonComponents/OPL/Text/Text';
import styled from '../../../theme/theme';

export const Content = styled(Text)({
  img: {
    maxWidth: '100%',
  },
});
